import { Dialog, Icon, ModalOverlay } from "@smartsuite/react-ui/lib";
import { observer } from "mobx-react-lite";
import { useRef } from "react";
import { useRootStore } from "../../stores/hooks";
import { useOnClickOutside } from "../../utils/hooks";
import { StyledDialogImage } from "./style";

export const ErrorModal = observer<Record<string, never>>(() => {
  const store = useRootStore().errorModal;
  const modalRef = useRef(null);

  useOnClickOutside(modalRef, () => {
    if (
      store.modal.closeOnClickOutside === undefined ||
      store.modal.closeOnClickOutside
    ) {
      store.closeModal();
    }
  });

  return (
    <ModalOverlay animation="none" active={store.open} closeByEsc={true}>
      <div ref={modalRef}>
        <Dialog.Wrapper size={store.modal.size} type="warning">
          {/* Dialog.Image doesn't work with our builder */}
          <StyledDialogImage>
            <Icon name={"sad"} color="currentColor" />
          </StyledDialogImage>
          <Dialog.Header>
            {store.modal.title != null && (
              <Dialog.Header.Heading text={store.modal.title} />
            )}
            {store.modal.description != null && (
              <Dialog.Header.Description text={store.modal.description} />
            )}
          </Dialog.Header>
          {store.modal.body != null && (
            <Dialog.Body fullWidth>{store.modal.body}</Dialog.Body>
          )}
        </Dialog.Wrapper>
      </div>
    </ModalOverlay>
  );
});
